// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.CompareVideo_scroll__Ah56j::-webkit-scrollbar {
  height: 8px;
}
.CompareVideo_scroll__Ah56j::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.CompareVideo_scroll__Ah56j::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.CompareVideo_CompareVideo__QLhAQ {
  background-color: var(--bgColor);
  border: 1px solid var(--borderColor);
  padding: 20px 20px 0 20px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_commentContainer__gTUMI {
  position: absolute;
  top: 10px;
}
body[dir=ltr] .CompareVideo_CompareVideo__QLhAQ .CompareVideo_commentContainer__gTUMI {
  right: 10px;
}
body[dir=rtl] .CompareVideo_CompareVideo__QLhAQ .CompareVideo_commentContainer__gTUMI {
  left: 10px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_Tabs__uM9\\+E {
  font-size: 14px !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  margin-bottom: 20px;
}
body[dir=ltr] .CompareVideo_CompareVideo__QLhAQ .CompareVideo_Tabs__uM9\\+E {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .CompareVideo_CompareVideo__QLhAQ .CompareVideo_Tabs__uM9\\+E {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_Tabs__ArTab__p-6F1 {
  -webkit-border-end: 1px solid var(--borderColor);
          border-inline-end: 1px solid var(--borderColor);
  -webkit-margin-end: 20px;
          margin-inline-end: 20px;
  -webkit-padding-end: 20px;
          padding-inline-end: 20px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_active__G8LFK {
  color: var(--secondaryColor);
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoHeader__M2qBz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_VideoName__N62DD {
  display: flex;
  align-items: center;
  max-width: 330px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_VideoName__N62DD a {
  text-decoration: none;
  font-size: 14px;
  text-transform: none;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 295px;
  font-family: "LatoBold", "CairoBold";
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_VideoName__ColorBox__UNEmA {
  min-width: 12px;
  height: 12px;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_videoDetailsInfo__u8cTz {
  display: block;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_videoContent__EtsFk {
  width: calc(100% - 220px);
}
@media (max-width: 992px) {
  .CompareVideo_CompareVideo__QLhAQ .CompareVideo_videoContent__EtsFk {
    width: 100%;
  }
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoImg__ag-gJ {
  position: relative;
  max-width: 330px;
  -webkit-margin-end: 30px;
          margin-inline-end: 30px;
  cursor: pointer;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoImg__ag-gJ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
@media (max-width: 992px) {
  .CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoImg__ag-gJ {
    -webkit-margin-end: 0px;
            margin-inline-end: 0px;
    margin-bottom: 30px;
    max-width: 100%;
  }
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoDetails__2xocy {
  display: flex;
  align-items: flex-start;
}
@media (max-width: 992px) {
  .CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoDetails__2xocy {
    flex-direction: column;
  }
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_VideoBtn__2ZEI4 {
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--bgColor);
  width: 37px;
  height: 37px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--secondaryColor);
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_sectionSeparator__Viefa {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--borderColor);
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_sectionSeparator__Viefa:last-child {
  margin-bottom: 0;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_infoTitle__DNeJg {
  line-height: 22px;
  text-transform: capitalize;
  color: var(--mainColor);
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoInfo__j3FKJ {
  width: 100%;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_countsData__7fGtk {
  display: flex;
  justify-content: space-between;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_countsData__7fGtk .CompareVideo_counts__SEG8a {
  font-size: 24px !important;
  line-height: 22px;
  font-weight: 700;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_countsData__7fGtk div {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_middleSection__ipICe {
  display: flex;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_middleSection__ipICe div:first-child {
  flex-basis: 30%;
  -webkit-margin-end: 15px;
          margin-inline-end: 15px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_middleSection__ipICe p {
  font-size: 12px !important;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_middleSection__ipICe.CompareVideo_videoUploadedSection__EpmBZ div:nth-child(2) {
  -webkit-margin-end: 35px;
          margin-inline-end: 35px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordion-root {
  margin-top: 0;
  border: 0;
  display: flex;
  flex-direction: column;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiPaper-elevation1 {
  box-shadow: none;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordionSummary-root {
  padding: 12px 0;
  min-height: 0;
  min-height: initial;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--borderColor);
  order: 1;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordionSummary-root.Mui-expanded {
  min-height: 0;
  min-height: initial;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordionSummary-content {
  margin: 0;
  flex-grow: initial;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
  color: var(--mainColor);
  font-size: 10px !important;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordionSummary-content.Mui-expanded {
  margin: 0;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiAccordionDetails-root {
  padding: 0 0 0 0;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  -webkit-margin-start: 153px;
          margin-inline-start: 153px;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .MuiIconButton-edgeEnd {
  margin-right: 0;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .CompareVideo_accordionContent__lZ16f {
  padding: 10px 0;
  width: 50%;
}
.CompareVideo_CompareVideo__QLhAQ .CompareVideo_compareVideoCollapse__Zv9nk .CompareVideo_accordionContent__lZ16f pre {
  margin-top: 5px;
  font-size: 12px !important;
  white-space: pre-line;
  overflow: hidden;
  font-family: inherit;
}

.videoType {
  width: 12px;
  height: 12px;
  display: inline-block;
}
.videoType.positive {
  border: 1px solid var(--secondaryColor);
  background-color: rgba(158, 166, 65, 0.2);
}
.videoType.negative {
  border: 1px solid #ff1300;
  background-color: rgba(255, 19, 0, 0.2);
}
.videoType.neutral {
  border: 1px solid #ffa700;
  background-color: rgba(255, 167, 0, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/app/components/CompareVideo/CompareVideo.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,gCAAA;EACA,oCAAA;EACA,yBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,SAAA;AAuDJ;AAtDI;EACE,WAAA;AAwDN;AAtDI;EACE,UAAA;AAwDN;AArDE;ED8FE,0BAAA;EC5FA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAuDJ;ADkCI;EACE,2DAAA;AChCN;ADkCI;EACE,2DAAA;AChCN;AA5DI;EACE,gDAAA;UAAA,+CAAA;EACA,wBAAA;UAAA,uBAAA;EACA,yBAAA;UAAA,wBAAA;AA8DN;AA3DE;EACE,4BAAA;AA6DJ;AA3DE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA6DJ;AA3DE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA6DJ;AA5DI;EACE,qBAAA;EACA,eAAA;EACA,oBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oCAAA;AA8DN;AA5DI;EACE,eAAA;EACA,YAAA;EACA,wBAAA;UAAA,uBAAA;AA8DN;AA3DE;EACE,cAAA;AA6DJ;AA3DE;EACE,yBAAA;AA6DJ;AD8BE;EC5FA;IAGI,WAAA;EA+DJ;AACF;AA7DE;EACE,kBAAA;EACA,gBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,eAAA;AA+DJ;AA9DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAgEN;ADcE;ECtFA;IAYI,uBAAA;YAAA,sBAAA;IACA,mBAAA;IACA,eAAA;EAgEJ;AACF;AA9DE;EACE,aAAA;EACA,uBAAA;AAgEJ;ADGE;ECrEA;IAKI,sBAAA;EAiEJ;AACF;AA/DE;EACE,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;AAiEJ;AA/DE;EACE,mBAAA;EACA,oBAAA;EACA,2CAAA;AAiEJ;AA/DE;EACE,gBAAA;AAiEJ;AA9DE;EACE,iBAAA;EACA,0BAAA;EACA,uBAAA;AAgEJ;AA7DE;EACE,WAAA;AA+DJ;AA7DE;EACE,aAAA;EACA,8BAAA;AA+DJ;AA9DI;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;AAgEN;AA9DI;EACE,wBAAA;UAAA,uBAAA;AAgEN;AA7DE;EACE,aAAA;AA+DJ;AA9DI;EACE,eAAA;EACA,wBAAA;UAAA,uBAAA;AAgEN;AA9DI;EACE,0BAAA;AAgEN;AA9DI;EACE,wBAAA;UAAA,uBAAA;AAgEN;AA3DM;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AA6DR;AA3DM;EACE,gBAAA;AA6DR;AA1DM;EACE,eAAA;EACA,aAAA;EAAA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,QAAA;AA4DR;AA1DQ;EACE,aAAA;EAAA,mBAAA;AA4DV;AAxDM;EACE,SAAA;EACA,kBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,uBAAA;ED5EJ,0BAAA;ACuIJ;AAxDQ;EACE,SAAA;EACA,wBAAA;UAAA,uBAAA;AA0DV;AAtDM;EACE,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,2BAAA;UAAA,0BAAA;AAwDR;AArDM;EACE,eAAA;AAuDR;AApDI;EACE,eAAA;EAEA,UAAA;AAqDN;AApDM;EACE,eAAA;EACA,0BAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;AAsDR;;AAhDE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AAmDJ;AAlDI;EACE,uCAAA;EACA,yCAAA;AAoDN;AAlDI;EACE,yBAAA;EACA,uCAAA;AAoDN;AAlDI;EACE,yBAAA;EACA,wCAAA;AAoDN","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.CompareVideo {\n  background-color: var(--bgColor);\n  border: 1px solid var(--borderColor);\n  padding: 20px 20px 0 20px;\n  .commentContainer {\n    position: absolute;\n    top: 10px;\n    #{$ltr} & {\n      right: 10px;\n    }\n    #{$rtl} & {\n      left: 10px;\n    }\n  }\n  .Tabs {\n    @include fontSize(14);\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    cursor: pointer;\n    margin-bottom: 20px;\n    &__ArTab {\n      border-inline-end: 1px solid var(--borderColor);\n      margin-inline-end: 20px;\n      padding-inline-end: 20px;\n    }\n  }\n  .active {\n    color: var(--secondaryColor);\n  }\n  .compareVideoHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n  }\n  .VideoName {\n    display: flex;\n    align-items: center;\n    max-width: 330px;\n    a {\n      text-decoration: none;\n      font-size: 14px;\n      text-transform: none;\n      margin-inline-end: 10px;\n      display: block;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      max-width: 295px;\n      font-family: 'LatoBold', 'CairoBold';\n    }\n    &__ColorBox {\n      min-width: 12px;\n      height: 12px;\n      margin-inline-end: 10px;\n    }\n  }\n  .videoDetailsInfo {\n    display: block;\n  }\n  .videoContent {\n    width: calc(100% - 220px);\n    @include Sm {\n      width: 100%;\n    }\n  }\n  .compareVideoImg {\n    position: relative;\n    max-width: 330px;\n    margin-inline-end: 30px;\n    cursor: pointer;\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    @include Sm {\n      margin-inline-end: 0px;\n      margin-bottom: 30px;\n      max-width: 100%;\n    }\n  }\n  .compareVideoDetails {\n    display: flex;\n    align-items: flex-start;\n\n    @include Sm {\n      flex-direction: column;\n    }\n  }\n  .VideoBtn {\n    position: absolute;\n    display: block;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--bgColor);\n    width: 37px;\n    height: 37px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--secondaryColor);\n  }\n  .sectionSeparator {\n    margin-bottom: 10px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid var(--borderColor);\n  }\n  .sectionSeparator:last-child {\n    margin-bottom: 0;\n    // border-bottom: none;\n  }\n  .infoTitle {\n    line-height: 22px;\n    text-transform: capitalize;\n    color: var(--mainColor);\n  }\n\n  .compareVideoInfo {\n    width: 100%;\n  }\n  .countsData {\n    display: flex;\n    justify-content: space-between;\n    .counts {\n      font-size: 24px !important;\n      line-height: 22px;\n      font-weight: 700;\n    }\n    div {\n      margin-inline-end: 10px;\n    }\n  }\n  .middleSection {\n    display: flex;\n    div:first-child {\n      flex-basis: 30%;\n      margin-inline-end: 15px;\n    }\n    p {\n      font-size: 12px !important;\n    }\n    &.videoUploadedSection div:nth-child(2) {\n      margin-inline-end: 35px;\n    }\n  }\n  .compareVideoCollapse {\n    :global {\n      .MuiAccordion-root {\n        margin-top: 0;\n        border: 0;\n        display: flex;\n        flex-direction: column;\n      }\n      .MuiPaper-elevation1 {\n        box-shadow: none;\n      }\n\n      .MuiAccordionSummary-root {\n        padding: 12px 0;\n        min-height: unset;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-top: 1px solid var(--borderColor);\n        order: 1;\n\n        &.Mui-expanded {\n          min-height: unset;\n        }\n      }\n\n      .MuiAccordionSummary-content {\n        margin: 0;\n        flex-grow: unset;\n        margin-inline-end: 10px;\n        color: var(--mainColor);\n        @include fontSize(10);\n\n        &.Mui-expanded {\n          margin: 0;\n          margin-inline-end: 10px;\n        }\n      }\n\n      .MuiAccordionDetails-root {\n        padding: 0 0 0 0;\n        display: flex;\n        align-items: flex-end;\n        justify-content: flex-start;\n        margin-inline-start: 153px;\n      }\n\n      .MuiIconButton-edgeEnd {\n        margin-right: 0;\n      }\n    }\n    .accordionContent {\n      padding: 10px 0;\n      // border-top: 1px solid var(--borderColor);\n      width: 50%;\n      pre {\n        margin-top: 5px;\n        font-size: 12px !important;\n        white-space: pre-line;\n        overflow: hidden;\n        font-family: inherit;\n      }\n    }\n  }\n}\n:global {\n  .videoType {\n    width: 12px;\n    height: 12px;\n    display: inline-block;\n    &.positive {\n      border: 1px solid var(--secondaryColor);\n      background-color: rgba(158, 166, 65, 0.2);\n    }\n    &.negative {\n      border: 1px solid #ff1300;\n      background-color: rgba(255, 19, 0, 0.2);\n    }\n    &.neutral {\n      border: 1px solid #ffa700;\n      background-color: rgba(255, 167, 0, 0.2);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `CompareVideo_scroll__Ah56j`,
	"CompareVideo": `CompareVideo_CompareVideo__QLhAQ`,
	"commentContainer": `CompareVideo_commentContainer__gTUMI`,
	"Tabs": `CompareVideo_Tabs__uM9+E`,
	"Tabs__ArTab": `CompareVideo_Tabs__ArTab__p-6F1`,
	"active": `CompareVideo_active__G8LFK`,
	"compareVideoHeader": `CompareVideo_compareVideoHeader__M2qBz`,
	"VideoName": `CompareVideo_VideoName__N62DD`,
	"VideoName__ColorBox": `CompareVideo_VideoName__ColorBox__UNEmA`,
	"videoDetailsInfo": `CompareVideo_videoDetailsInfo__u8cTz`,
	"videoContent": `CompareVideo_videoContent__EtsFk`,
	"compareVideoImg": `CompareVideo_compareVideoImg__ag-gJ`,
	"compareVideoDetails": `CompareVideo_compareVideoDetails__2xocy`,
	"VideoBtn": `CompareVideo_VideoBtn__2ZEI4`,
	"sectionSeparator": `CompareVideo_sectionSeparator__Viefa`,
	"infoTitle": `CompareVideo_infoTitle__DNeJg`,
	"compareVideoInfo": `CompareVideo_compareVideoInfo__j3FKJ`,
	"countsData": `CompareVideo_countsData__7fGtk`,
	"counts": `CompareVideo_counts__SEG8a`,
	"middleSection": `CompareVideo_middleSection__ipICe`,
	"videoUploadedSection": `CompareVideo_videoUploadedSection__EpmBZ`,
	"compareVideoCollapse": `CompareVideo_compareVideoCollapse__Zv9nk`,
	"accordionContent": `CompareVideo_accordionContent__lZ16f`
};
export default ___CSS_LOADER_EXPORT___;
